<template>
    <div>
        <vs-row vs-w="12">
            <vs-col vs-w="4" vs-sm="12">
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view" v-if="projectTemplate.name">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ projectTemplate.name }}</td>
                        </tr>
                    </table>
                    <h6 class="mt-6">{{$t("Description")}}</h6>
                    <p style="white-space: pre-wrap" class="mt-3">{{ projectTemplate.description }}</p>

                    <vs-divider/>
                    <vs-button v-if="$checkPermission(206)" class="mt-3 mr-3" color="warning" icon-pack="feather" icon="icon-edit" type="border" @click="editProjectTemplatePrompt = true" >{{$t("Edit")}}</vs-button>
                    <vs-button v-if="$checkPermission(209)" class="mt-5 mr-3" style="float: left" color="success" icon-pack="feather" icon="icon-plus-circle" type="border" @click="createProjectFromTemplatePrompt = true" >{{$t("CreateProjectFromTemplate")}}</vs-button>
                    <vs-button v-if="$checkPermission(201)" class="mt-5" style="float: left" color="success" icon-pack="feather" icon="icon-plus-circle" type="border" @click="createOfferFromTemplatePrompt = true" >{{$t("CreateProjectOfferFromTemplate")}}</vs-button>
                    <div style="clear: both"/>

                    <vs-popup :title="$t('Edit')" :active.sync="editProjectTemplatePrompt">
                        <div>
                            <p class="mt-6">{{$t("Name")}}</p>
                            <vs-input v-model="projectTemplateEdit['name']" style="width: 100%"></vs-input>
                            <p class="mt-6">{{$t("Description")}}</p>
                            <vs-textarea v-model="projectTemplateEdit['description']" class="w-full" />
                            <vs-divider/>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editProjectTemplate">{{$t("Change")}}</vs-button>
                            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeProjectTemplate">{{$t("Delete")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
            </vs-col>
        </vs-row>

        <vx-card :title='$t("ProjectTemplateTasks")'>
            <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="projectTemplateTasks">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center">
                        <vs-button v-if="$checkPermission(206)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addProjectTemplateTaskPrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ projectTemplateTasks.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : projectTemplateTasks.length }} of {{ projectTemplateTasks.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="title">{{$t("TaskTitle")}}</vs-th>
                    <vs-th sort-key="description">{{$t("Description")}}</vs-th>
                    <vs-th sort-key="hours">{{$t("HourNumber")}}</vs-th>
                    <vs-th sort-key="deadline_days">{{$t("DeadlineFromStart")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].title">
                            {{ data[index].title }}
                        </vs-td>

                        <vs-td :data="data[index].description">
                            {{ data[index].description }}
                        </vs-td>

                        <vs-td :data="data[index].hours">
                            {{ data[index].hours }}
                        </vs-td>

                        <vs-td :data="data[index].deadline_days">
                            {{ data[index].deadline_days }}
                        </vs-td>

                    </vs-tr>
                    </tbody>
                </template>

            </vs-table>

            <vs-popup :title="$t('Add')" :active.sync="addProjectTemplateTaskPrompt">
                <div>
                    <p class="mt-6">{{$t("TaskTitle")}}</p>
                    <vs-input v-model="projectTemplateTaskAdding['title']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("HourNumber")}}</p>
                    <vs-input v-model="projectTemplateTaskAdding['hours']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                    <vs-input v-model="projectTemplateTaskAdding['deadline_days']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("Description")}}</p>
                    <vs-textarea v-model="projectTemplateTaskAdding['description']" class="w-full" />
                    <vs-divider/>
                    <vs-button color="success" type="border" class="mt-6; mr-1" @click="addProjectTemplateTask">{{$t("Add")}}</vs-button>
                </div>
            </vs-popup>

            <vs-popup :title="$t('Edit')" :active.sync="editProjectTemplateTaskPrompt">
                <div>
                    <p class="mt-6">{{$t("TaskTitle")}}</p>
                    <vs-input v-model="projectTemplateTaskEdit['title']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("HourNumber")}}</p>
                    <vs-input v-model="projectTemplateTaskEdit['hours']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                    <vs-input v-model="projectTemplateTaskEdit['deadline_days']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("Description")}}</p>
                    <vs-textarea v-model="projectTemplateTaskEdit['description']" class="w-full" />
                    <vs-divider/>
                    <vs-button v-if="$checkPermission(206)" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editProjectTemplateTask">{{$t("Change")}}</vs-button>
                    <vs-button v-if="$checkPermission(206)" style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeProjectTemplateTask">{{$t("Delete")}}</vs-button>
                </div>
            </vs-popup>

            <vs-popup :title="$t('Add')" :active.sync="createProjectFromTemplatePrompt">
                <div>
                    <p class="mt-6">{{$t("Name")}}</p>
                    <vs-input v-model="projectAdding['name']" style="width: 100%"/>
                    <p class="mt-6">{{$t("Client")}}</p>
                    <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectAdding['client_company_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
                    </vs-select>
                    <p class="mt-6">{{$t("BranchOffice")}}</p>
                    <vs-select autocomplete class="selectExample" v-model="projectAdding['branch_office_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                    </vs-select>
                    <p class="mt-6">{{$t("AssignedUser")}}</p>
                    <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectAdding['company_user_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                    </vs-select>
                    <vs-divider/>
                    <vs-button color="success" type="border" class="mt-6; mr-1" @click="addProject">{{$t("Add")}}</vs-button>
                </div>
            </vs-popup>

            <vs-popup :title="$t('Add')" :active.sync="createOfferFromTemplatePrompt">
                <div>
                    <p class="mt-6">{{$t("Name")}}</p>
                    <vs-input v-model="projectAdding['name']" style="width: 100%"/>
                    <p class="mt-6">{{$t("Client")}}</p>
                    <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectAdding['client_company_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
                    </vs-select>
                    <p class="mt-6">{{$t("BranchOffice")}}</p>
                    <vs-select autocomplete class="selectExample" v-model="projectAdding['branch_office_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                    </vs-select>
                    <vs-divider/>
                    <vs-button color="success" type="border" class="mt-6; mr-1" @click="addOffer">{{$t("Add")}}</vs-button>
                </div>
            </vs-popup>

        </vx-card>

    </div>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                projectTemplateTasks: [],

                projectTemplate: {},
                projectTemplateEdit: {},

                itemsPerPage: 20,
                isMounted: false,

                addProjectTemplateTaskPrompt: false,
                editProjectTemplateTaskPrompt: false,
                editProjectTemplatePrompt: false,

                projectTemplateTaskAdding: {},
                projectTemplateTaskEdit: {},

                createProjectFromTemplatePrompt: false,
                createOfferFromTemplatePrompt: false,

                projectAdding: {},
                branchOffices: [{}],


            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                this.projectTemplateTaskEdit = tr;
                this.editProjectTemplateTaskPrompt = true;
            },
            updateProjectTemplate(){
                const thisIns = this;
                this.$http.get('/api/v1/projectTemplate/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.projectTemplate = response.data;
                        thisIns.projectTemplateEdit = thisIns.projectTemplate;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateProjectTemplateTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/projectTemplate/' + this.$route.params.id + "/task")
                    .then(function (response) {
                        thisIns.projectTemplateTasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addProjectTemplateTask() {
                const thisIns = this;
                this.$http.post('/api/v1/projectTemplate/' + this.$route.params.id + "/task", {
                    title: this.projectTemplateTaskAdding.title,
                    description: this.projectTemplateTaskAdding.description,
                    hours: Number(this.projectTemplateTaskAdding.hours),
                    deadline_days: Number(this.projectTemplateTaskAdding.deadline_days)
                }).then(function () {
                        thisIns.addProjectTemplateTaskPrompt = false;
                        thisIns.updateProjectTemplateTasks();
                        thisIns.projectTemplateTaskAdding = {}
                    }).catch(function (error) {
                    thisIns.addProjectTemplateTaskPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editProjectTemplateTask(){
                const thisIns = this;
                this.$http.put('/api/v1/projectTemplate/' + this.$route.params.id + "/task/" + this.selected.id, {
                    title: this.projectTemplateTaskEdit.title,
                    description: this.projectTemplateTaskEdit.description,
                    hours: Number(this.projectTemplateTaskEdit.hours),
                    deadline_days: Number(this.projectTemplateTaskEdit.deadline_days)
                }).then(function () {
                    thisIns.updateProjectTemplateTasks();
                    thisIns.editProjectTemplateTaskPrompt = false;
                }).catch(function (error) {
                    thisIns.editProjectTemplateTaskPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeProjectTemplateTask(){
                const thisIns = this;
                this.$http.delete('/api/v1/projectTemplate/' + this.$route.params.id + "/task/" + this.selected.id)
                    .then(function () {
                        thisIns.updateProjectTemplateTasks();
                        thisIns.editProjectTemplateTaskPrompt = false;
                    }).catch(function (error) {
                    thisIns.editProjectTemplateTaskPrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            },
            editProjectTemplate(){
                const thisIns = this;
                this.$http.put('/api/v1/projectTemplate/' + this.$route.params.id, this.projectTemplateEdit)
                .then(function () {
                    thisIns.updateProjectTemplateTasks();
                    thisIns.editProjectTemplatePrompt = false;
                }).catch(function (error) {
                    thisIns.editProjectTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeProjectTemplate(){
                const thisIns = this;
                this.$http.delete('/api/v1/projectTemplate/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editProjectTemplatePrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/projectTemplates')
                        });
                    }).catch(function (error) {
                    thisIns.editProjectTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            },
            addProject(){
                const thisIns = this;
                this.$http.post('/api/v1/projectTemplate/' + this.$route.params.id + '/project', this.projectAdding)
                    .then(function (response) {
                        thisIns.createProjectFromTemplatePrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/project/' + response.data)
                        });
                    }).catch(function (error) {
                    thisIns.createProjectFromTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addOffer(){
                const thisIns = this;
                this.$http.post('/api/v1/projectTemplate/' + this.$route.params.id + '/offer', this.projectAdding)
                    .then(function (response) {
                        thisIns.createOfferFromTemplatePrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/offer/' + response.data)
                        });
                    }).catch(function (error) {
                    thisIns.createOfferFromTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        watch: {
            editProjectTemplateTaskPrompt: function () {
                if(!this.editProjectTemplateTaskPrompt){
                    this.selected = {}
                }
            },
            'projectAdding.client_company_id': function () {
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.projectAdding["client_company_id"] + "/branch_offices")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        thisIns.projectAdding['branch_office_id'] = thisIns.branchOffices[0].id
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        created() {
            this.updateProjectTemplateTasks();
            this.updateProjectTemplate();
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addProjectTemplateTaskPrompt){
                this.addProjectTemplateTaskPrompt = false;
                next(false)
            }else if(this.editProjectTemplateTaskPrompt){
                this.editProjectTemplateTaskPrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
